module.exports = __webpack_public_path__ + "static/img/thumb_3.4276ca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_3.png
// module id = 4T+f
// module chunks = 0